import React from 'react';
import { Table, Divider } from 'antd';
import { BulbOutlined, BarChartOutlined, CheckCircleOutlined } from '@ant-design/icons';
import type { AIExplanation } from '../types';

interface AIPanelProps {
  explanation: AIExplanation;
}

const AIPanel: React.FC<AIPanelProps> = ({ explanation }) => {
  const overviewColumns = [
    { title: '指标', dataIndex: 'metric', key: 'metric', width: 120 },
    { title: '值', dataIndex: 'value', key: 'value' },
  ];

  const overviewData = explanation.data_overview.map((item, i) => ({
    ...item,
    key: i,
  }));

  return (
    <div
      style={{
        background: 'var(--primary-light, #ede9fe)',
        border: '1px solid var(--border-purple, #b9b9f9)',
        borderRadius: 'var(--radius, 6px)',
        padding: 24,
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
        <span style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 12,
          color: 'var(--primary)',
          opacity: 0.6,
        }}>//</span>
        <h2 style={{
          margin: 0, fontSize: 16, fontWeight: 600,
          color: 'var(--primary, #533afd)',
        }}>
          AI 分析解读
        </h2>
      </div>

      <p style={{
        fontSize: 13, color: 'var(--text-body)', lineHeight: 1.7, marginBottom: 20,
      }}>
        {explanation.summary}
      </p>

      <Divider orientation="left" style={{ fontSize: 13, color: 'var(--text-primary)' }}>
        <BarChartOutlined /> 数据概况
      </Divider>
      <Table
        columns={overviewColumns}
        dataSource={overviewData}
        pagination={false}
        size="small"
        bordered
        style={{ marginBottom: 20 }}
      />

      <Divider orientation="left" style={{ fontSize: 13, color: 'var(--text-primary)' }}>
        <BulbOutlined /> 核心发现
      </Divider>
      <ul style={{ paddingLeft: 20, marginBottom: 20 }}>
        {explanation.key_findings.map((finding, i) => (
          <li key={i} style={{ fontSize: 13, color: 'var(--text-body)', lineHeight: 1.7, marginBottom: 4 }}>
            {finding}
          </li>
        ))}
      </ul>

      <Divider orientation="left" style={{ fontSize: 13, color: 'var(--text-primary)' }}>
        <CheckCircleOutlined /> 结论与建议
      </Divider>
      <ul style={{ paddingLeft: 20 }}>
        {explanation.recommendations.map((rec, i) => (
          <li key={i} style={{ fontSize: 13, color: 'var(--text-body)', lineHeight: 1.7, marginBottom: 4 }}>
            {rec}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AIPanel;
